import { useLocation } from 'react-router-dom';

import AppHeader from './AppHeader';
import RouteEffects from './RouteEffects';
import SearchTransitionOverlay from './SearchTransitionOverlay';
import { ToastProvider } from './ToastProvider';
import { NavigationMotionProvider } from '../motion/NavigationMotionContext';
import { SearchCommandProvider } from '../app/SearchCommandContext';

function PageLayout({ children }) {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <ToastProvider>
      <NavigationMotionProvider>
        <SearchCommandProvider>
          <div className={`app-shell${isHome ? ' app-shell--home' : ''}`}>
            <a className="skip-link" href="#main-content">Skip to main content</a>
            <AppHeader />
            <RouteEffects />
            <main id="main-content" className={`app-main${isHome ? ' app-main--home' : ''}`}>
              {children}
            </main>
            <SearchTransitionOverlay />
          </div>
        </SearchCommandProvider>
      </NavigationMotionProvider>
    </ToastProvider>
  );
}

export default PageLayout;
